import { Dispatch } from "redux";
import { createSlice } from "@reduxjs/toolkit";
import * as serverRequest from "../../_apis/CrucibleApi";

export interface CONFIG_INITIAL_STATE {
  error: boolean;
  isThemeLoading: boolean;
  theme: any;
  content: any;
}

const initialState: CONFIG_INITIAL_STATE = {
  error: false,
  isThemeLoading: false,
  theme: {},
  content: {
    connectScreen: {
      header: "Connect your wallet to access Crucible Dashboard",
    },
    dashboard: {
      header: "Crucible By Ferrum Network",
      subHeader: "Crucible By Ferrum Network",
    },
    introduction: {
      header: "Welcome To The Crucible by Ferrum Network",
      description:
        "Watch the explainer video below for a step-by-step tutorial on how to mint, add liquidity, farm, trade, and earn rewards through the Crucible!",
      benefits: {
        header: "Crucible Benefits",
        description:
          "Below are just a few of the incredible features of The Crucible.",
        benefitsList: [
          "Ecosystem of Autonomous Sustainable Farming Pools",
          "Sustainable Rewards Economy",
          "Built-in Token Burn",
          "Mint, Add Liquidity, Farm, Trade, and Earn Rewards",
        ],
      },
    },
    farmDashboard: {
      farmCard: {
        header: " Crucible Farm Dashboard",
      },
      tokenCard: {
        header: " Crucible Token",
        stakeContent: "Your Crucible Farm Stake",
      },
    },
    approveAndMint: {
      header: "Deposit and Mint Crucible Token",
    },
    withdraw: {
      header: "Withdraw Crucible Stake Rewards",
    },
    stake: {
      header: "Stake",
    },
    unstake: {
      header: "Unstake",
    },
    unwrap: {
      header: "Unwrap Crucible Token",
    },
    success: {
      header: "Crucible Token Sustainable Farming",
      description:
        "Congrats! You have successfully unstaked your cFRM tokens. You can now use the tokens to generate even more rewards by adding liquidity for the cFRM - BNB pair and staking it. You can also generate rewards by trading the tokens or unwrap the tokens.",
      cards: [
        {
          header: "cFRM/BNB Mint and Stake",
          description: "Now you can proceed to Mint and Stake cFRM LP tokens",
        },
        {
          header: "Mint cFRM",
          description:
            "You can always mint more cFRM to increase your pool share.",
        },
        {
          header: "Go to cFRM Leaderboard Competition",
          description:
            "Check out the cFRM Leaderboard and participate in the competition to generate rewards.",
        },
        {
          header: "Trade cFRM",
          description:
            "You can always mint more cFRM to increase your pool share.",
        },
      ],
    },
  },
};

const slice = createSlice({
  name: "contract",
  initialState,
  reducers: {
    startLoading(state) {
      state.isThemeLoading = true;
    },
    catchError(state, action) {
      state.isThemeLoading = false;
      state.error = action.payload;
    },
    loadConfigurationData(state, action) {
      state.theme = action.payload.theme;
      state.isThemeLoading = false;
    },
    resetConfigState(state) {
      state.error = false;
      state.isThemeLoading = false;
      state.theme = undefined;
    },
  },
});

export default slice.reducer;

export const loadWhiteLabelConfig =
  (siteName: string) => (dispatch: Dispatch) => {
    dispatch(slice.actions.startLoading());
    return serverRequest
      .getWhitelabelDetails(siteName)
      .then((response: any) => {
        dispatch(
          slice.actions.loadConfigurationData({
            theme: response.data.body.organizationWhiteLables,
          })
        );
      })
      .catch((error: any) => {});
  };
